module.exports = __webpack_public_path__ + "img/magnifyingGlassIcon.60cd1671.png";